import React from 'react';
import { Helmet } from 'react-helmet';
import PageTransition from '../../components/ui/PageTransition';
import ErrorHero from './components/ErrorHero';
import HomeButton from './components/HomeButton';
import NavFallback from './components/NavFallback';
import SupportLink from './components/SupportLink';

// Inline keyframes for logo pulse and geometric pattern
const globalStyles = `
  @keyframes winLogoPulse {
    0%, 100% { transform: scale(1.0); }
    50% { transform: scale(1.05); }
  }
`;

export default function ErrorPage404() {
  return (
    <>
      <Helmet>
        <title>404 — Page Not Found | WIN</title>
        <style>{globalStyles}</style>
      </Helmet>

      {/* Full-viewport royal blue background */}
      <div
        className="min-h-screen w-full flex items-center justify-center relative overflow-hidden"
        style={{ backgroundColor: '#0B1F3B' }}
      >
        {/* Subtle gold geometric pattern overlay */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `
              repeating-linear-gradient(
                45deg,
                rgba(212,165,32,0.04) 0px,
                rgba(212,165,32,0.04) 1px,
                transparent 1px,
                transparent 40px
              ),
              repeating-linear-gradient(
                -45deg,
                rgba(212,165,32,0.04) 0px,
                rgba(212,165,32,0.04) 1px,
                transparent 1px,
                transparent 40px
              )
            `,
          }}
        />

        {/* Centered content */}
        <PageTransition>
          <div className="relative z-10 flex flex-col items-center px-6 py-16">
            <ErrorHero />
            <HomeButton />
            <NavFallback />
            <SupportLink />
          </div>
        </PageTransition>
      </div>
    </>
  );
}
